import classNames from 'classnames'

import classes from './BusinessDashboard.module.scss'
import { ReactComponent as MoneyCheckCircle } from '../../../../assets/images/common/icons/money-check-dollar-circle.svg'
import PropTypes from 'prop-types'
import ButtonLink from '../../../common/buttons/ButtonLink'

const Placeholder = ({ communityHasEnrollments, hasDataWithoutRevenue, isRevenue }) => {
  const title = communityHasEnrollments
    ? (isRevenue
      ? (hasDataWithoutRevenue ? 'Revenue Not Tracked' : 'No Revenue Found' )
      : 'No Registrations Found')
    : 'No Registrations or Revenue'

  const body = communityHasEnrollments
    ? (hasDataWithoutRevenue
      ? 'Registrations are active, but no pricing packages are attached to these programs.' +
      ' Add a pricing package to your program to automatically track revenue here.'
      : 'There\'s no revenue or enrollment activity in the selected date range. Try adjusting your filters.')
    : 'This dashboard will come to life once you start registering golfers. Make sure your programs are published and have pricing packages attached.'

  const buttonText = hasDataWithoutRevenue ? 'Create a Package' : 'View Programs'
  const buttonNavigateTo = hasDataWithoutRevenue ? '/pricing' : '/programs'

  return (
    <div className={classNames('d-flex flex-column justify-content-center align-items-center text-center', classes.placeholder)}>
      <MoneyCheckCircle className={classes.icon} />
      <h3 className={classNames('my-3', classes.noActivitiesTitle)}>{title}</h3>
      <p className={classes.noActivitiesText}>{body}</p>
      <ButtonLink
        navigateTo={buttonNavigateTo}
        noTopMargin
        className={classes.placeholderButton}
      >
        {buttonText}
      </ButtonLink>
    </div>
  )
}

Placeholder.propTypes = {
  communityHasEnrollments: PropTypes.bool,
  isRevenue: PropTypes.bool,
  hasDataWithoutRevenue: PropTypes.bool,
}

export default Placeholder
